/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ContractDepartmentDepartmentDto,
  UpdateContractDepartmentDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetOrganigramUrl = () => {




  return `/api/ContractDepartment/GetOrganigram`
}

export const getOrganigram = async ( options?: Parameters<typeof customInstance>[1]): Promise<ContractDepartmentDepartmentDto[]> => {

  return customInstance<ContractDepartmentDepartmentDto[]>(getGetOrganigramUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganigramQueryKey = () => {
    return [
    `/api/ContractDepartment/GetOrganigram`
    ] as const;
    }


export const getGetOrganigramQueryOptions = <TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganigramQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganigram>>> = ({ signal }) => getOrganigram({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganigramQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganigram>>>
export type GetOrganigramQueryError = ErrorType<unknown>


export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganigram>>,
          TError,
          Awaited<ReturnType<typeof getOrganigram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganigram>>,
          TError,
          Awaited<ReturnType<typeof getOrganigram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganigramQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganigramSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganigramQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganigram>>> = ({ signal }) => getOrganigram({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganigramSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganigram>>>
export type GetOrganigramSuspenseQueryError = ErrorType<unknown>


export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganigramSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateContractDepartmentUrl = () => {




  return `/api/ContractDepartment/UpdateContractDepartment`
}

export const updateContractDepartment = async (updateContractDepartmentDto?: UpdateContractDepartmentDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateContractDepartmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateContractDepartmentDto)
  }
);}





export const getUpdateContractDepartmentMutationKey = () => ['updateContractDepartment'] as const;

export const getUpdateContractDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractDepartment>>, TError,UpdateContractDepartmentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContractDepartment>>, TError,UpdateContractDepartmentMutationVariables, TContext> => {

const mutationKey = getUpdateContractDepartmentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContractDepartment>>, UpdateContractDepartmentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateContractDepartment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateContractDepartment>>>
    export type UpdateContractDepartmentMutationBody = BodyType<UpdateContractDepartmentDto> | undefined
    export type UpdateContractDepartmentMutationError = ErrorType<unknown>
    export type UpdateContractDepartmentMutationVariables = {data?: BodyType<UpdateContractDepartmentDto>}

    export const useUpdateContractDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractDepartment>>, TError,UpdateContractDepartmentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContractDepartment>>,
        TError,
        UpdateContractDepartmentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateContractDepartmentMutationOptions(options), queryClient);
    }
